module.exports = __webpack_public_path__ + "img/Google_Pay_Global.a7bd07a7.png";